import ComparisonResultData from '../../../entities/ComparisonResultData'
import ComparisonResultCategory from '../../../entities/ComparisonResultCategory'

const getAvailableCategories = (resultData: ComparisonResultData | undefined): ComparisonResultCategory[] => {
    return resultData?.categories?.filter(category => category.id !== 'model') || []
}

export default getAvailableCategories
